<template>
    <div class="samara">
        <Navbar/>
        <b-container fluid id="inicio" class="banner">
            <b-row class="banner-section align-items-center">
                <b-col class="pl-0 pr-0">
                    <img src="../assets/imgs/samarabanner.png" alt="">
                </b-col>
            </b-row>
        </b-container>
        <b-container class="samarasection text-center" fluid>
            <b-row>
                <b-col>
                    <img class="mb-3" src="../assets/imgs/logo_samara.svg" alt="">
                    <p class="m-auto">Bienvenido a <b>Samara, el primer Residencial Boutique en Mexicali.</b><br>
                        En Samara, redefinimos el significado de exclusividad al combinar diseño sofisticado, confort y privacidad en un entorno íntimo y armonioso. A diferencia de los grandes desarrollos habitacionales, aquí encontrarás un número limitado de residencias con una arquitectura cuidadosamente diseñada, materiales de la más alta calidad y amenidades premium, pensadas para elevar tu bienestar y estilo de vida.</p>
                </b-col>
            </b-row>
        </b-container>
        <b-container class="samaraubicacion">
            <b-row>
                <b-col md="6" align-self="center">
                    <h4>Ubicación</h4>
                    <p>Ubicado en un entorno privilegiado sobre Avenida Eucalipto a tan solo unos metros de calle Novena entre Calzada Cetys y Calzada Independencia. Justo en el área de mayor desarrollo y proyección de la Zona Dorada de Mexicali.</p>
                </b-col>
                <b-col md="6" align-self="center">
                    <img class="img-fluid" src="../assets/imgs/mapa.png" alt="">
                </b-col>
            </b-row>
        </b-container>
        <b-container fluid>
            <b-row>
                <b-col class="pl-0 pr-0">
                    <img class="img-fluid samara-centro" src="../assets/imgs/samaracentro.png" alt="">
                </b-col>
            </b-row>
        </b-container>
        <b-container class="amenidades text-center carrouselNosotros m-auto">
            <b-row class="">
                <b-col class="mb-4" md="12">
                    <h4>Amenidades</h4>
                    <p><b><i>SAMARA Residencial Boutique</i></b> brinda amenidades de primer nivel:</p>
                </b-col>
                <b-col md="12">
                    <VueSlickCarousel v-bind="slickOptions" :arrows="true" :dots="false">
                        <div class="text-center">
                            <img class="img-fluid m-auto" src="../assets/imgs/amenidades1.png" alt="">
                            <p class="mt-4">Alberca con chapoteadero y jacuzzi</p>
                        </div>
                        <div>
                            <img class="img-fluid m-auto" src="../assets/imgs/amendiades2.png" alt="">
                            <p class="mt-4">Juegos infantiles</p>
                        </div>
                        <div class="text-center">
                            <img class="img-fluid m-auto" src="../assets/imgs/amenidades3.png" alt="">
                            <p class="mt-4">Cancha de pádel</p>
                        </div>
                        <div class="text-center">
                            <img class="img-fluid m-auto" src="../assets/imgs/amendiades4.png" alt="">
                            <p class="mt-4">Terraza para eventos</p>
                        </div>
                        <div class="text-center">
                            <img class="img-fluid m-auto" src="../assets/imgs/amenidades5.png" alt="">
                            <p class="mt-4">Seguridad 24/7 y acceso controlado</p>
                        </div>
                    </VueSlickCarousel>
                </b-col>
            </b-row>
        </b-container>
        <b-container class="residencia" fluid>
            <b-row>
                <b-col>
                    <h4>Residencia</h4>
                    <p><b><i>En SAMARA Residencial Boutique</i></b>, cada residencia ha sido diseñada bajo un concepto de confort absoluto y arquitectura moderna, priorizando la funcionalidad y el bienestar de sus residentes.</p>
                    <p>Con un diseño de una sola planta, estos hogares ofrecen espacios amplios, luminosos y perfectamente distribuidos, eliminando barreras para una vida más cómoda y práctica.</p>
                    <p>La combinación de líneas contemporáneas, materiales de alta calidad y una distribución inteligente crea un ambiente sofisticado, ideal para quienes buscan armonía entre diseño y comodidad.</p>
                </b-col>
            </b-row>
        </b-container>
        <b-container class="modelos" fluid>
            <b-row>
                <b-col class="text-center" md="12">
                    <h4>Modelos</h4>
                </b-col>
                <b-col class="mb-4" md="4">
                    <b-card
                        :img-src="require('../assets/imgs/imgelizam.png')"
                        img-alt="Eliza"
                        img-top
                        class="mb-2 card1"
                    >
                        <b-card-text>
                            <p><b>Eliza</b></p>
                            <b-row>
                                    <span class="pl-3">252 m<sup>2</sup> de terreno</span>
                                  
                                    <span class="pl-4">168.62 m<sup>2</sup> de construcción</span>
                                
                            </b-row>
                        </b-card-text>

                        <b-button class="btn-proyecto" :href="$router.resolve({ name: 'eliza' }).href" variant="primary">Ver Modelo <img src="../assets/imgs/arrow4.svg" alt=""></b-button>
                    </b-card>
                </b-col>
                <b-col class="mb-4" md="4">
                    <b-card
                        :img-src="require('../assets/imgs/imgisam.png')"
                        img-alt="Isabella"
                        img-top
                        class="mb-2 card2"
                    >
                        <b-card-text>
                            <p><b>Isabella</b></p>

                            <b-row>
                                <span class="pl-3">288 m<sup>2</sup> de terreno</span>
                                <span class="pl-4">191.91 m<sup>2</sup> de construcción</span>
                            </b-row>
                        </b-card-text>

                        <b-button class="btn-proyecto" :href="$router.resolve({ name: 'isabella' }).href" variant="primary">Ver Modelo <img src="../assets/imgs/arrow4.svg" alt=""></b-button>
                    </b-card>
                </b-col>
                <b-col class="mb-4" md="4">
                    <b-card
                        :img-src="require('../assets/imgs/imgalexm.png')"
                        img-alt="Alexandra"
                        img-top
                        class="mb-2 card3"
                    >
                        <b-card-text>
                            <p><b>Alexandra</b></p>

                            <b-row>
                                <span class="pl-3">321 m<sup>2</sup> de terreno</span>
                                <span class="pl-4">205 m<sup>2</sup> de construcción</span>
                            </b-row>
                        </b-card-text>

                        <b-button class="btn-proyecto" :href="$router.resolve({ name: 'alexandra' }).href" variant="primary">Ver Modelo <img src="../assets/imgs/arrow4.svg" alt=""></b-button>
                    </b-card>
                </b-col>
            </b-row>
            <b-row class="text-center">
                <a class="ml-auto mr-2" href="https://www.facebook.com/profile.php?id=61570880402334"><img src="../assets/imgs/fbcafe.svg"></a>
                <a class="mr-auto ml-2" href="https://www.instagram.com/samara.residencial.boutique/"><img src="../assets/imgs/instacafe.svg"></a>
            </b-row>
        </b-container>
        <Contact/>
        <div class="whatsapp">
            <a href="https://api.whatsapp.com/send/?phone=526863912095&amp;app_absent=0" target="_blank">
                <img src="../assets/imgs/whatsapp.png" alt="Whatsapp">
            </a>
        </div>
    </div>
</template>

<script>
    import Navbar from '../components/Navbar.vue'
    import Contact from '../components/Contact.vue'
    import VueSlickCarousel from 'vue-slick-carousel'
    import 'vue-slick-carousel/dist/vue-slick-carousel.css'
    // optional style for arrows & dots
    import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
    export default {
        components: {
            VueSlickCarousel,
            Navbar,
            Contact
        },
        data() {
            return {
                slickOptions: {
                    autoplay: true,
                    autoplaySpeed: 10000,
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    focusOnSelect: true,
                    speed: 1000,
                }
            }
        }
    }
</script>

<style scoped>
.samara{
    padding-top: 100px;
}
.carrouselNosotros{
    max-width: 70vw !important;
}
/* BANNER */
.banner img{
    width: 100%;
}
.samarasection{
    padding: 7%;
    background-image: url('../assets/imgs/textura.png'); /* The image used */
    background-position: center; /* Center the image */
    background-repeat: no-repeat; /* Do not repeat the image */
    background-size: cover; /* Resize the background image to cover the entire container */
}
.samarasection p{
    max-width: 771px;
}
.samara-centro{
    width: 100%;
}
.samaraubicacion{
    padding: 70px 0;
}
.amenidades{
    padding: 100px 0 50px 0;
}
.residencia{
    padding: 7%;
    text-align: center;
    background-image: url('../assets/imgs/textura.png'); /* The image used */
    background-position: center; /* Center the image */
    background-repeat: no-repeat; /* Do not repeat the image */
    background-size: cover; /* Resize the background image to cover the entire container */
}
.residencia p{
    max-width: 885px;
    margin-left: auto;
    margin-right: auto;
}
.modelos{
    padding: 7%;
}
.card{
    width: 100%;
    border: none;
    border-radius: 30px;
}
.card1{
    box-shadow: 0px 14px 38.7px 0px #C5C29799;
}
.card2{
    box-shadow: 0px 14px 38.7px 0px #BDD4DA99;
}
.card3{
    box-shadow: 0px 14px 38.7px 0px #DABFA499;
}
.card-text span{
    color: #8A8A8A;
    font-size: 15px;
}
.btn-proyecto{
    background: #000 !important;
    color: #fff !important;
    border: none;
    width: 155px;
    font-size: 18px;
}
@media (max-width: 992px) {
    .samara{
        padding-top: 60px;
    }
    .samarasection{
        padding: 50px 7%;
    }
    .samaraubicacion{
        padding: 50px 7%;
    }
}
@media (max-width: 768px) {

}
</style>